import moment from 'moment';
import { routerApp, baseUrl, enableHybrid, enableOnPremise } from '../app.module';
import hybridService from '../services/hybrid'

routerApp.controller('vesselPerformanceController', ['$rootScope', 'ReportsApiService', 'ReportService', 'VesselSpecificationService', '$state', '$scope', '$http', '$timeout', 'PollingService',  'OfflineDatabase', 'notify',
    function($rootScope, ReportsApiService, ReportService, VesselSpecificationService, $state, $scope, $http, $timeout, PollingService, OfflineDatabase, notify) {

    $rootScope.selectedLevels = ['vessel-reports', 'view-performance'];

    $scope.vesselSpecs = VesselSpecificationService.getSpecifications();
    $scope.ciiReportingOnlyEnabled = function() {
        return $scope.selectedVessel?.ciiReportingOnlyEnabled;
    }
    
    $scope.$on('vessel-reports-list', function() {
        var rs = ReportService.getVesselReportsList();
        var offlineReports = $rootScope.offlineReports;
        $scope.reports = (enableHybrid || enableOnPremise) ? OfflineDatabase.manageOnlineReportsDisplay(offlineReports, rs) : rs;
    });

    // get reports list from service
    var rs = ReportService.getVesselReportsList();
    var offlineReports = $rootScope.offlineReports;
    $scope.reports = (enableHybrid || enableOnPremise) ? OfflineDatabase.manageOnlineReportsDisplay(offlineReports, rs) : rs;

    $scope.$watch('reports[0]', function(newValue) {
        $rootScope.lastReportWasPortOrAnchor = false;
        var lastReport = newValue;
        if (lastReport && lastReport.status == 'completed') {
            $rootScope.lastReportWasPortReport = lastReport.reportType == 'Port';
            $rootScope.lastReportWasAnchor = lastReport.reportType == 'Anchor';
            $rootScope.lastReportWasPortOrAnchor = $rootScope.lastReportWasPortReport || $rootScope.lastReportWasAnchor;
        }
    });

    $scope.isLoadingReports = ReportsApiService.isLoadingReports;

    // opens the selected performance report from the view reports view, if the
    // report is the same as the one currently being edited, use the logic for
    // loading the edited report (so don't load it from the server)
    $scope.openReport = function(report) {
        var reportId = report.id;
        console.log('getting report from report service');
        ReportsApiService.getReport($scope.selectedVessel.id, reportId).then(function(response) {
            var report = response.data;
            report = ReportService.applyDatesOnReport(report, report);
            report.id = report["_id"]["$oid"];
            var targetState = ReportsApiService.getReportView(report);
            $state.go(targetState, { report: report, viewReport: true });
        }).catch(error => console.error(error));
    };

    $scope.getReadableReportType = function(report) {
        if (report._cls == 'Report.SeaReport') {
            if (report.operational.arriving) {
                return 'Sea (Arrival)';
            }
            return 'Sea';
        } else if (report._cls == 'Report.ManeuveringReport') {
            if (report.operational.maneuvering_type === 'departure') {
                return 'Departure';
            }
            return 'Maneuvering';
        } else if (report._cls == 'Report.PortReport') {
            return 'Port';
        } else if (report._cls == 'Report.AnchorReport') {
            if (report.operational.anchor_drifting === 'drifting') {
                return 'Drifting';
            }
            return 'Anchor';
        } else {
            return '-';
        }
    }

    $scope.sortBy = function(sortField) {
        $scope.reverse = ($scope.sortField === sortField) ? !$scope.reverse : false;
        $scope.sortField = sortField;
    };

    $scope.extractData = function() {
        var url = baseUrl + $scope.selectedVessel.id + "/extract";
        var parameters = [];

        if ($scope.query != undefined && $scope.query.reportFrom != undefined) {
            parameters.push("report_from=" + $scope.query.reportFrom);
        }
        if ($scope.query != undefined && $scope.query.reportTo != undefined) {
            parameters.push("report_to=" + $scope.query.reportTo);
        }

        if (parameters.length == 0 && ($rootScope.selectedVessel.name == 'M.V. Viking Coral' || $rootScope.selectedVessel.name == 'M.V. Viking Bravery' || $rootScope.selectedVessel.name == 'M.V. Viking Chance')) {
            var filename = "/extracts/TVA - " + $rootScope.selectedVessel.name + " - Data Extract.xlsx";
            window.open(filename);
            return;
        }

        url += "?" + parameters.join("&");

        $rootScope.downloadDisabled = true;
        $rootScope.downloadButtonText = "Preparing Data";
        $http({
            url: url,
            method: "GET"
        }).then(function(response) {
            var data = response.data;
            $scope.extractId = data.data;
            $scope.extractMessage = "Preparing Data ...";

            var pollUrl = baseUrl + $scope.extractId + "/extractFile";
            var pollIntervalId = setInterval(function() {
                console.log('attempting to download');
                $http({
                    url: pollUrl,
                    method: "GET"
                }).then(function(response) {
                    var data = response.data;
                    var extractData = data.data;
                    var failed = extractData.failed;
                    if (failed != undefined && failed) {
                        PollingService.clearAllIntervals();
                        return;
                    }

                    var downloadUrl = extractData.download_url;
                    if (downloadUrl == undefined || downloadUrl == "") {
                        console.log('response received, need to wait a bit more');
                    } else {
                        PollingService.clearAllIntervals();
                        console.log('response received, success!');

                        $rootScope.downloadButtonText = $rootScope.staticDownloadButtonText;
                        $rootScope.downloadDisabled = false;

                        window.open(downloadUrl);
                        $scope.extractMessage = "";

                    }
                }, function(error) {
                    PollingService.clearAllIntervals();
                    console.log(error);
                    $scope.downloadDisabled = false;
                });
            }, 5000);
            PollingService.addInterval(pollIntervalId);
        }, function(response) {
            $scope.downloadButtonText = "Extraction Error";
            $timeout(function() {
                $rootScope.downloadButtonText = $rootScope.staticDownloadButtonText;
            }, 2000);
            $scope.downloadDisabled = false;
        });
    }

    $scope.updateDateTo = function(newValue) {

        $scope.date_to = newValue;
    }
    $scope.updateDateFrom = function(newValue) {

        $scope.date_from = newValue;
    }

    $scope.reportFilter = function(query) {
        return function(item) {
            if (query != null) {

                var date = moment(item.reportTo);

                // to date
                var to = query.reportTo;
                if (to != undefined && to != "" && date > moment(to, 'DD/MM/YYYY HH:mm')) {
                    return false;
                }

                // from date
                var from = query.reportFrom;
                if (from != undefined && from != "" && date < moment(from, 'DD/MM/YYYY HH:mm')) {
                    return false;
                }

                // bf filter
                var bfValues = query.bfScale;
                var reportBfScale = String(item.bfScale);
                if (bfValues != undefined && reportBfScale != undefined) {
                    var found = false;
                    for (var i = 0; i < bfValues.length; i++) {
                        if (bfValues[i] == 'All' || reportBfScale == bfValues[i]) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        return false;
                    }
                }

                // draught filter
                var draught = query.meanDraught;
                if (draught != undefined && !item.meanDraught.toFixed(1).startsWith(draught)) {
                    return false;
                }

                // type filter
                var reportType = query.typeFilter;
                if (reportType != undefined && !item.reportType.startsWith(reportType)) {
                    return false;
                }
            }

            return true;
        }
    };

    $scope.bfOptions = ["All", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    function encodeReport(report, forClipboard=false) {
        var subject = '[tva-offline]: ' + $rootScope.selectedVessel.name + ' - ' + $scope.getReadableReportType(report) + ' - ' + report.operational.report_to;
        var newline = forClipboard? '\n': '%0D%0A';
        var body = 'Dear Navfleet Performance Support' + newline + newline;
        body += 'Please find below data our recently submitted report.' + newline + newline;
        body += 'Best Regards,' + newline + newline + newline + newline;
        body += 'This email has been auto-generated from NavFleet Performance online. Please do not make any changes to this section.' + newline;
        body += '-----------------' + newline;
        body += btoa(JSON.stringify(report)) + newline;
        body += '-----------------' + newline;
        return [subject, body];
    };

    function updateReportEmailStatus(reportKey, hasBeenSent) {
        hybridService.serverReportsGet(reportKey).then(function(report) {
            report.emailSent = hasBeenSent;
            hybridService.serverReportsPut(report);
            $scope.refreshOfflineReports()
        });
    };

    $scope.updateReportEmailStatus = updateReportEmailStatus;

    $scope.createEmailReport = function(report) {
        // this is a backup option for vessels to email us reports in base 64 emails so that NavFleet Performance is able to parse them
        var toAddress = 'performance-report@navtor.com';
        var result = encodeReport(report);
        var subject = result[0];
        var body = result[1];
        var href = 'mailto:' + toAddress + '?subject=' + subject + '&body=' + body;
        window.open(href);

        // set the 'emailSent' status to true on report
        // then refresh list of offline reports
        var reportKey = OfflineDatabase.getReportKey(report);
        updateReportEmailStatus(reportKey, true)
    };

    $scope.generateEmailReport = function(report) {
       // this is a backup-backup option for vessels with email not configurable with mailto: to email us reports in base 64 emails onto webso that NavFleet Performance is able to parse them
        var result = encodeReport(report, true);
        var subject = result[0];
        var body = result[1];
        var reportKey = OfflineDatabase.getReportKey(report);
        $rootScope.emailReport = {
            email: 'performance-report@navtor.com',
            subject: subject,
            body: body,
            reportNumber: report.report_number,
            reportKey: reportKey
        };
    };

    $rootScope.syncingOfflineReports = false;

    function applyTimeoutByPass(offlineReport) {
        var report = offlineReport.report;
        var reportKey = OfflineDatabase.getReportKey(report).replace(/\s/g, '');
        // check if submitting
        var currentUrl = offlineReport.url;
        var submitting = currentUrl.indexOf('?submit=true') > -1;
        var urlTagToByPassTimeout = currentUrl
        if (submitting) {
            urlTagToByPassTimeout = currentUrl + '&bypass_timeout_tag=' + reportKey; 
        } else {
            urlTagToByPassTimeout = currentUrl + '?bypass_timeout_tag=' + reportKey;
        }
        offlineReport.url = urlTagToByPassTimeout;
        return offlineReport;
    }

    $scope.syncOfflineReports = function() {
        if (!enableHybrid) return;
        $rootScope.syncingOfflineReports = true;
        hybridService.serverReportsQuery()
        .then(function (reports) {
            if (reports.length > 0) {
                notify({message: 'Syncing offline reports to server', duration: 3000, classes: ['warning-notification']})
                reports = reports.sort(function(a, b) { return a.report.report_number - b.report.report_number; }).map(function(report) { return applyTimeoutByPass(report)})
                let result = reports.reduce(function(promiseChain, req) {
                    return promiseChain.then(function(response) {
                        return $http({
                            method: req.method,
                            url: req.url, 
                            data: req.body})
                            .then(function(response) {
                                let isNotAuthenticated = response.status == 401;
	                            if (isNotAuthenticated) throw Error(response.statusText);
	                            return response;
                            })
                            .then(function(response) {
                            if (req.reportStatus === 'ready' || response.status == 409) {
                                return hybridService.serverReportsRemove(req.reportKey);
                            }
                        }, function(err) {
                            notify({message: 'Cannot sync to server, please check internet connection', duration: 5000, classes: ['bad-notification']})
                            return;
                        })
                    }).catch(function(err) {console.log(err)})
                }, Promise.resolve(null));
                
                return result.then(function(response) {
                    // all reports have synced
                    $rootScope.syncingOfflineReports = false;
                    $scope.goOnlineMode();
                })
            } else {
                $scope.syncingOfflineReports = false;
                notify({message: 'No offline reports to sync', duration: 3000, classes: ['ok-notification']})
                return;
            }
        })
        
    };
}]);
